import { z } from 'zod';

import client from '@/lib/feathers';
import { realtimeMessagesSchema } from '@/types/database/realtimeMessages';

const realtimeMessagesService = client.service('realtimeMessages');

const messageDataSchema = realtimeMessagesSchema.element.omit({ _id: true });

type MessageData = z.infer<typeof messageDataSchema>;

export const createRealtimeMessage = async (messages: MessageData) => {
  const validateResult = messageDataSchema.safeParse(messages);
  if (!validateResult.success) {
    console.error({ messages });
    throw new Error(validateResult.error.message);
  }
  await realtimeMessagesService.create(messages);
};
